import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Slider from "react-slick";
import { fetchAuspiciantesPrem } from "../action/AuspicianteActionsPrem";
import { Link } from "react-router-dom";

export const Auspiciantes = React.memo(({ ciudad = '' }) => {
  const dispatch = useDispatch();
  
  // Memoizar configuración del servidor
  const config_server = useMemo(() => {
    return JSON.parse(localStorage.getItem("configServer"));
  }, []);
  
  const auspiciantesPrem = useSelector((state) => state.auspiciantesPrem);

  useEffect(() => {
    const loadAuspiciantesPrem = () => dispatch(fetchAuspiciantesPrem(ciudad));
    loadAuspiciantesPrem();
  }, [dispatch, ciudad]);

  // Memoizar settings del slider
  const settings = useMemo(() => ({
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    adaptiveHeight: false,
  }), []);

  // Memoizar el contenido renderizado
  const renderedContent = useMemo(() => {
    if (!auspiciantesPrem.items) {
      return <div className="imagen-home-promociones1-oculto"></div>;
    }

    return (
      <Slider
        style={{ height: "150px", maxHeight: "150px" }}
        {...settings}
      >
        {auspiciantesPrem.items.map((auspiciante) => {
          return (
            <Link 
              key={auspiciante.id_auspiciante} 
              target="_blank" 
              to={{ pathname: auspiciante.webpage_auspiciante }}
            >
              <img
                className='imageAuspiciante'
                src={`${config_server.linkImageAuspiciante}${auspiciante.imagen_auspiciante}`}
                style={{
                  width: "100%",
                  height: "150px",
                  maxHeight: "150px",
                  minHeight: "150px",
                }}
                alt="Catalogos"
                loading="lazy"
              />
            </Link>
          );
        })}
      </Slider>
    );
  }, [auspiciantesPrem.items, settings, config_server.linkImageAuspiciante]);

  return (
    <div style={{ height: "150px" }}>
      {renderedContent}
    </div>
  );
});

Auspiciantes.displayName = 'Auspiciantes';

